import React from 'react';
import { graphql, StaticQuery } from 'gatsby';

import { Img } from 'components';

import { styled, Colors } from 'themes';
import { device } from 'themes/media-queries';

const Steps = ({ steps }) => (
  <div>
    {steps.map(({ imageSmall, imageLarge, title, text }, index) => {
      return (
        <Step
          key={title}
          imageSmall={imageSmall}
          imageLarge={imageLarge}
          title={title}
          text={text}
          num={index + 1}
        />
      );
    })}
  </div>
);

export default Steps;

const StepComponent = ({
  imageSmall,
  imageLarge,
  title,
  text,
  num,
  data: { quarter, half, full },
}) => {
  return (
    <React.Fragment>
      <SmallStepWrapper>
        <StepImageContainer>
          <SmallStepImage fluid={imageSmall.fluid} />
          <SmallStepNum num={num}>{num}</SmallStepNum>
        </StepImageContainer>
        <TitleContainer num={num}>
          <h4>{title}</h4>
          <p>{text}</p>
        </TitleContainer>
      </SmallStepWrapper>
      <LargeStepWrapper>
        <LargeStepImageContainer num={num}>
          <LargeStepImage fluid={imageLarge.fluid} />
        </LargeStepImageContainer>
        <StepNumContainer>
          {num === 1 && (
            <StepNumImage25>
              <Img fluid={quarter.fluid} />
            </StepNumImage25>
          )}
          {num === 2 && (
            <StepNumImage50>
              <Img fluid={half.fluid} />
            </StepNumImage50>
          )}
          {num === 5 && (
            <StepNumImage100>
              <Img fluid={full.fluid} />
            </StepNumImage100>
          )}
          <LargeStepNum>{num}</LargeStepNum>
        </StepNumContainer>
        <TitleContainer num={num}>
          <h4>{title}</h4>
          <p style={{ marginBottom: 0 }}>{text}</p>
        </TitleContainer>
      </LargeStepWrapper>
    </React.Fragment>
  );
};

const Step = props => (
  <StaticQuery
    query={graphql`
      query {
        quarter: imageSharp(fluid: { originalName: { regex: "/25.png/" } }) {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
        half: imageSharp(
          fluid: { originalName: { regex: "/progress-50.png/" } }
        ) {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
        full: imageSharp(fluid: { originalName: { regex: "/100.png/" } }) {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    `}
    render={data => <StepComponent data={data} {...props} />}
  />
);

const LargeStepWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.4fr 1fr;
  justify-content: center;
  align-items: center;

  @media ${device.mobileL} {
    display: none;
  }
`;

const SmallStepWrapper = styled.div`
  display: none;
  @media ${device.mobileL} {
    display: block;
  }
`;

const LargeStepImageContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: ${({ num }) => (num % 2 ? 'flex-end' : 'flex-start')};
  margin-top: -5em;
  order: ${({ num }) => (num % 2 ? 0 : 1)};
  z-index: 10;

  @media ${device.laptopL} {
    margin-top: 0em;
  }
`;

const LargeStepImage = styled(Img)`
  width: 100%;
  height: 100%;
`;

const StepImageContainer = styled.div`
  position: relative;
`;

const SmallStepImage = styled(Img)`
  width: 100%;
  height: auto;
  margin-bottom: 1.3em;
  z-index: 10;
`;

const TitleContainer = styled.div`
  align-self: center;
  text-align: ${({ num }) => (num % 2 ? 'left' : 'right')};
  order: ${({ num }) => (num % 2 ? 1 : -1)};
  z-index: 10;
`;

const StepNumContainer = styled.div`
  position: relative;
`;

const StepNumImage25 = styled.div`
  position: absolute;
  bottom: 0%;
  left: 50%;
  transform: translate(-85%, -50%);
  width: 18em;
`;

const StepNumImage50 = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-0%, -50%);
  width: 12em;
`;

const StepNumImage100 = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 24em;
`;

const LargeStepNum = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 7.2rem;
  color: ${Colors.darkOrange};
  font-weight: bold;
`;

const SmallStepNum = styled.div`
  position: absolute;
  top: 50%;
  left: ${({ num }) => (num % 2 ? 'initial' : 0)};
  right: ${({ num }) => (num % 2 ? 0 : 'initial')};
  transform: translate(0, -50%);
  font-size: 7.2rem;
  color: ${Colors.darkOrange};
  font-weight: bold;
`;
